import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/65999778086?text=Ol%C3%A1%21%20Gostaria%20de%20solicitar%20um%20hino%20no%20Louve."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco no WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20bd5a] text-white flex items-center justify-center shadow-lg shadow-black/30 hover:scale-110 transition-all duration-300 animate-fade-in"
    >
      <MessageCircle className="h-7 w-7 fill-current" />
    </a>
  );
};

export default WhatsAppButton;
